// prodViewData.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const prodViewData = (data: any) => {
    const cleanData = JSON.parse(JSON.stringify(data));

    if (Array.isArray(cleanData)) {
      return cleanData.map((item) => {
        if (item.event === 'prodView') {
          const ecomm = item.ecommerce?.ecommerce || item.ecommerce;
          return {
            ...item,
            ecommerce: {
              currency: ecomm.currency,
              items: ecomm.items,
            },
          };
        }
        return item;
      });
    }
    return cleanData;
  };
